var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    {
      staticClass: "drop-shadow afterSave",
      style: { border: "none" },
      attrs: { "max-width": "1000" },
    },
    [
      _c(
        "w-card-title",
        [
          _c("span", [_vm._v(_vm._s(_vm.modalTitle))]),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("common.close"),
                  expression: "$ct('common.close')",
                },
              ],
              attrs: {
                disabled: _vm.state.saveModalData.preventClose,
                white: "",
              },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times", right: "" } })],
            1
          ),
          _vm.state.saveModalData.loading || _vm.saveProgress != undefined
            ? _c("w-progress-linear", {
                staticClass: "full inTitle",
                attrs: {
                  height: "10",
                  value: _vm.saveProgress,
                  color: "#42af80",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            {
              staticClass: "content",
              attrs: { "no-margin": "", "no-padding": "", stretch: "" },
            },
            [
              _c("app-default-settings", { attrs: { state: _vm.state } }),
              _c("app-sale-edit-save-modal-actions", {
                attrs: { state: _vm.state },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }